export const IMAGE_PREFIX = process.env.REACT_APP_IMAGE_URL;
// export const IMAGE_PREFIX = "http://192.168.1.7:8000/storage/";

// https://api-reserve.wegsoft.com/api
